"use strict";
var Data_Eq = require("../Data.Eq/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Show_Generic = require("../Data.Show.Generic/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Newline = (function () {
    function Newline() {

    };
    Newline.value = new Newline();
    return Newline;
})();
var Spaces = (function () {
    function Spaces() {

    };
    Spaces.value = new Spaces();
    return Spaces;
})();
var SComment = (function () {
    function SComment() {

    };
    SComment.value = new SComment();
    return SComment;
})();
var MComment = (function () {
    function MComment() {

    };
    MComment.value = new MComment();
    return MComment;
})();

// | The ghost field distinguishes invisible tokens inserted by layout.
var Position = function (x) {
    return x;
};
var Subtoken = function (x) {
    return x;
};
var Subtokens = function (x) {
    return x;
};
var Ident = (function () {
    function Ident(value0) {
        this.value0 = value0;
    };
    Ident.create = function (value0) {
        return new Ident(value0);
    };
    return Ident;
})();
var Special = (function () {
    function Special(value0) {
        this.value0 = value0;
    };
    Special.create = function (value0) {
        return new Special(value0);
    };
    return Special;
})();
var Keyword = (function () {
    function Keyword() {

    };
    Keyword.value = new Keyword();
    return Keyword;
})();
var PseudoKeyword = (function () {
    function PseudoKeyword() {

    };
    PseudoKeyword.value = new PseudoKeyword();
    return PseudoKeyword;
})();
var ModId = (function () {
    function ModId() {

    };
    ModId.value = new ModId();
    return ModId;
})();
var LitInteger = (function () {
    function LitInteger() {

    };
    LitInteger.value = new LitInteger();
    return LitInteger;
})();
var LitFloat = (function () {
    function LitFloat() {

    };
    LitFloat.value = new LitFloat();
    return LitFloat;
})();
var LitChar = (function () {
    function LitChar() {

    };
    LitChar.value = new LitChar();
    return LitChar;
})();
var LitString = (function () {
    function LitString() {

    };
    LitString.value = new LitString();
    return LitString;
})();
var Eof = (function () {
    function Eof() {

    };
    Eof.value = new Eof();
    return Eof;
})();
var VarId = (function () {
    function VarId() {

    };
    VarId.value = new VarId();
    return VarId;
})();
var ConId = (function () {
    function ConId() {

    };
    ConId.value = new ConId();
    return ConId;
})();
var VarSym = (function () {
    function VarSym() {

    };
    VarSym.value = new VarSym();
    return VarSym;
})();
var ConSym = (function () {
    function ConSym() {

    };
    ConSym.value = new ConSym();
    return ConSym;
})();
var Token = function (x) {
    return x;
};
var subtokenToString = function (v) {
    return v.value;
};
var specialTag = new Special(false);
var showPosition = Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "column";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "ghosts";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "line";
}))(Data_Show.showRecordFieldsNil)(Data_Show.showInt))(Data_Maybe.showMaybe(Data_Show.showInt)))(Data_Show.showInt));
var pseudoKeyword = function (v) {
    return {
        value: v.value,
        type: v.type,
        tag: PseudoKeyword.value,
        position: v.position,
        before: v.before
    };
};
var lineOf = function (v) {
    return v.line;
};
var ghostTag = new Special(true);
var genericTag_ = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof Ident) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof Special) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
    };
    if (x instanceof Keyword) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
    };
    if (x instanceof PseudoKeyword) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
    };
    if (x instanceof ModId) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))));
    };
    if (x instanceof LitInteger) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))));
    };
    if (x instanceof LitFloat) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))));
    };
    if (x instanceof LitChar) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))));
    };
    if (x instanceof LitString) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))));
    };
    if (x instanceof Eof) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)))))))));
    };
    throw new Error("Failed pattern match at Haskell.Token (line 68, column 1 - line 68, column 50): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new Ident(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return new Special(x.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
        return Keyword.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
        return PseudoKeyword.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
        return ModId.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
        return LitInteger.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
        return LitFloat.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
        return LitChar.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))) {
        return LitString.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))))))) {
        return Eof.value;
    };
    throw new Error("Failed pattern match at Haskell.Token (line 68, column 1 - line 68, column 50): " + [ x.constructor.name ]);
});
var showTag_ = function (dictShow) {
    return new Data_Show.Show(Data_Show_Generic.genericShow(genericTag_)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(dictShow))(new Data_Symbol.IsSymbol(function () {
        return "Ident";
    })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showBoolean))(new Data_Symbol.IsSymbol(function () {
        return "Special";
    })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
        return "Keyword";
    })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
        return "PseudoKeyword";
    })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
        return "ModId";
    })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
        return "LitInteger";
    })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
        return "LitFloat";
    })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
        return "LitChar";
    })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
        return "LitString";
    })))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
        return "Eof";
    })))))))))))));
};
var genericSubtokenTag = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof Newline) {
        return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
    };
    if (x instanceof Spaces) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
    };
    if (x instanceof SComment) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
    };
    if (x instanceof MComment) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
    };
    throw new Error("Failed pattern match at Haskell.Token (line 71, column 1 - line 71, column 60): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return Newline.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return Spaces.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
        return SComment.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
        return MComment.value;
    };
    throw new Error("Failed pattern match at Haskell.Token (line 71, column 1 - line 71, column 60): " + [ x.constructor.name ]);
});
var showSubtokenTag = new Data_Show.Show(Data_Show_Generic.genericShow(genericSubtokenTag)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Newline";
})))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Spaces";
})))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "SComment";
})))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "MComment";
})))))));
var genericSubtoken = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var showSubtoken = new Data_Show.Show(Data_Show_Generic.genericShow(genericSubtoken)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "position";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "tag";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "value";
}))(Data_Show.showRecordFieldsNil)(Data_Show.showString))(showSubtokenTag))(showPosition))))(new Data_Symbol.IsSymbol(function () {
    return "Subtoken";
}))));
var showSubtokens = Data_Show.showArray(showSubtoken);
var genericIdentType = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof VarId) {
        return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
    };
    if (x instanceof ConId) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
    };
    if (x instanceof VarSym) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
    };
    if (x instanceof ConSym) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
    };
    throw new Error("Failed pattern match at Haskell.Token (line 69, column 1 - line 69, column 56): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return VarId.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return ConId.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
        return VarSym.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
        return ConSym.value;
    };
    throw new Error("Failed pattern match at Haskell.Token (line 69, column 1 - line 69, column 56): " + [ x.constructor.name ]);
});
var showIdentType = new Data_Show.Show(Data_Show_Generic.genericShow(genericIdentType)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "VarId";
})))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "ConId";
})))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "VarSym";
})))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "ConSym";
})))))));
var showToken = Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "before";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "position";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "tag";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "type";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "value";
}))(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Data_Show.showString))(showTag_(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "name";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "qual";
}))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
    return "type";
}))(Data_Show.showRecordFieldsNil)(showIdentType))(Data_Maybe.showMaybe(Data_Show.showString)))(Data_Show.showString)))))(showPosition))(showSubtokens));
var functorTag_ = new Data_Functor.Functor(function (f) {
    return function (m) {
        if (m instanceof Ident) {
            return new Ident(f(m.value0));
        };
        if (m instanceof Special) {
            return new Special(m.value0);
        };
        if (m instanceof Keyword) {
            return Keyword.value;
        };
        if (m instanceof PseudoKeyword) {
            return PseudoKeyword.value;
        };
        if (m instanceof ModId) {
            return ModId.value;
        };
        if (m instanceof LitInteger) {
            return LitInteger.value;
        };
        if (m instanceof LitFloat) {
            return LitFloat.value;
        };
        if (m instanceof LitChar) {
            return LitChar.value;
        };
        if (m instanceof LitString) {
            return LitString.value;
        };
        if (m instanceof Eof) {
            return Eof.value;
        };
        throw new Error("Failed pattern match at Haskell.Token (line 73, column 1 - line 73, column 44): " + [ m.constructor.name ]);
    };
});
var eqTag_ = function (dictEq) {
    return new Data_Eq.Eq(function (x) {
        return function (y) {
            if (x instanceof Ident && y instanceof Ident) {
                return Data_Eq.eq(dictEq)(x.value0)(y.value0);
            };
            if (x instanceof Special && y instanceof Special) {
                return x.value0 === y.value0;
            };
            if (x instanceof Keyword && y instanceof Keyword) {
                return true;
            };
            if (x instanceof PseudoKeyword && y instanceof PseudoKeyword) {
                return true;
            };
            if (x instanceof ModId && y instanceof ModId) {
                return true;
            };
            if (x instanceof LitInteger && y instanceof LitInteger) {
                return true;
            };
            if (x instanceof LitFloat && y instanceof LitFloat) {
                return true;
            };
            if (x instanceof LitChar && y instanceof LitChar) {
                return true;
            };
            if (x instanceof LitString && y instanceof LitString) {
                return true;
            };
            if (x instanceof Eof && y instanceof Eof) {
                return true;
            };
            return false;
        };
    });
};
var eqSubtokenTag = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Newline && y instanceof Newline) {
            return true;
        };
        if (x instanceof Spaces && y instanceof Spaces) {
            return true;
        };
        if (x instanceof SComment && y instanceof SComment) {
            return true;
        };
        if (x instanceof MComment && y instanceof MComment) {
            return true;
        };
        return false;
    };
});
var eqPosition = new Data_Eq.Eq(function (x) {
    return function (y) {
        return x.column === y.column && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqInt))(x.ghosts)(y.ghosts) && x.line === y.line;
    };
});
var eqSubtoken = new Data_Eq.Eq(function (x) {
    return function (y) {
        return Data_Eq.eq(eqPosition)(x.position)(y.position) && Data_Eq.eq(eqSubtokenTag)(x.tag)(y.tag) && x.value === y.value;
    };
});
var eqIdentType = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof VarId && y instanceof VarId) {
            return true;
        };
        if (x instanceof ConId && y instanceof ConId) {
            return true;
        };
        if (x instanceof VarSym && y instanceof VarSym) {
            return true;
        };
        if (x instanceof ConSym && y instanceof ConSym) {
            return true;
        };
        return false;
    };
});
var eqToken = function (v) {
    return function (v1) {
        return Data_Eq.eq(Data_Tuple.eqTuple(Data_Eq.eqString)(Data_Tuple.eqTuple(eqTag_(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
            return "type";
        }))(eqIdentType))()(new Data_Symbol.IsSymbol(function () {
            return "qual";
        }))(Data_Maybe.eqMaybe(Data_Eq.eqString)))()(new Data_Symbol.IsSymbol(function () {
            return "name";
        }))(Data_Eq.eqString))))(eqPosition)))(new Data_Tuple.Tuple(v.value, new Data_Tuple.Tuple(v.tag, v.position)))(new Data_Tuple.Tuple(v1.value, new Data_Tuple.Tuple(v1.tag, v1.position)));
    };
};
var conIdToModId = function (v) {
    return {
        value: v.value,
        type: v.type,
        tag: ModId.value,
        position: v.position,
        before: v.before
    };
};
var columnOf = function (v) {
    return v.column;
};
module.exports = {
    Token: Token,
    Position: Position,
    Ident: Ident,
    Special: Special,
    Keyword: Keyword,
    PseudoKeyword: PseudoKeyword,
    ModId: ModId,
    LitInteger: LitInteger,
    LitFloat: LitFloat,
    LitChar: LitChar,
    LitString: LitString,
    Eof: Eof,
    VarId: VarId,
    ConId: ConId,
    VarSym: VarSym,
    ConSym: ConSym,
    specialTag: specialTag,
    ghostTag: ghostTag,
    Subtokens: Subtokens,
    Subtoken: Subtoken,
    Newline: Newline,
    Spaces: Spaces,
    SComment: SComment,
    MComment: MComment,
    subtokenToString: subtokenToString,
    eqToken: eqToken,
    columnOf: columnOf,
    lineOf: lineOf,
    conIdToModId: conIdToModId,
    pseudoKeyword: pseudoKeyword,
    genericTag_: genericTag_,
    genericIdentType: genericIdentType,
    genericSubtoken: genericSubtoken,
    genericSubtokenTag: genericSubtokenTag,
    functorTag_: functorTag_,
    eqTag_: eqTag_,
    eqIdentType: eqIdentType,
    eqPosition: eqPosition,
    eqSubtoken: eqSubtoken,
    eqSubtokenTag: eqSubtokenTag,
    showSubtokens: showSubtokens,
    showPosition: showPosition,
    showToken: showToken,
    showSubtoken: showSubtoken,
    showSubtokenTag: showSubtokenTag,
    showTag_: showTag_,
    showIdentType: showIdentType
};
